import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import { Button, colors } from "@repo/ui";
import PageContainer from "../../../components/PageContainer/PageContainer";
import withAuth from "../../../hoc/withAuth/withAuth";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_PaymentSuccessPage";

const PaymentSuccessPage: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const [translationsLoaded, setTranslationsLoaded] = useState(false);

  useEffect(() => {
    const loadTranslations = async () => {
      setTranslationsLoaded(true);
    };
    loadTranslations();
  }, []);

  const handleContinue = () => {
    navigate("/my-table/share");
  };

  if (!translationsLoaded) {
    return <div>Loading translations...</div>;
  }

  return (
    <PageContainer startColor="white" endColor={colors.background}>
      <div className="mt-16"></div>
      <AnimatedCard title={t("title")} className="bg-white max-w-4xl w-full">
        <p className="mb-8">{t("description")}</p>
        <Button
          label={t("continue-button")}
          onClick={handleContinue}
          type="primary"
          className="w-full"
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(PaymentSuccessPage));
